import { useSetupAvigilonVideoConnectorMutation } from 'apollo/generated/client-operations';
import { AlertService } from 'components/alertService';
import type { ConnectorSetupDrawerProps } from 'containers/jobsiteConfiguration/tabs/connectors/drawers/connectorCatalogEntry';
import { ConnectorSetupDrawerLayout } from 'containers/jobsiteConfiguration/tabs/connectors/drawers/shared/ConnectorSetupDrawerLayout';
import React from 'react';
import { getGraphQLError } from 'utils/error';

export function AvigilonVideoConnectorSetupDrawer({
  isOpen,
  siteId,
  catalogItem,
  onClose,
  onCreated,
  onBack,
}: ConnectorSetupDrawerProps): React.ReactElement {
  const [setup, setupState] = useSetupAvigilonVideoConnectorMutation();

  const connect = async (): Promise<void> => {
    try {
      await setup({ variables: { input: { siteId } } });
      await onCreated();
      onClose();
      AlertService.alert(
        'success',
        `${catalogItem.displayName} connected`,
        null,
      );
    } catch (error) {
      await onCreated();
      onClose();
      AlertService.alert(
        'danger',
        `Could not connect ${catalogItem.displayName}`,
        getGraphQLError(error),
      );
    }
  };

  return (
    <ConnectorSetupDrawerLayout
      isOpen={isOpen}
      title={catalogItem.displayName}
      loading={setupState.loading}
      actionEnabled={catalogItem.available}
      actionText="Connect"
      onAction={connect}
      onClose={onClose}
      onBack={onBack}
    >
      <p className="odin-text-sm odin-leading-6 odin-text-gray-600">
        {catalogItem.setupDescription}
      </p>
    </ConnectorSetupDrawerLayout>
  );
}
